import React from 'react'
import { useSelector } from 'react-redux'
import { Debug } from 'components/debug'

import type { FormModel } from './ModelFormField'

type ModelDebugOwnProps = {
  model: FormModel
  pk: unknown
}

const ModelDebug = ({ model, pk }: ModelDebugOwnProps) => {
  const selectItem = React.useMemo(() => model.getItem(pk), [model, pk])
  const item = useSelector(selectItem) as object
  return <Debug {...{ model, pk }} {...item} />
}
export default ModelDebug
